const AI_ENABLED_PLANS = new Set(["business", "enterprise"]);

export function hasAiAccess(user) {
  const plan = String(user?.workspace_plan_tier || user?.plan_tier || "").toLowerCase();
  return AI_ENABLED_PLANS.has(plan);
}
